// Vocabulario de marcas de estado.
//
// Emoji em vez de cor: funciona impresso em preto e branco, na tela do celular
// no sol do campo, e para quem nao distingue verde de vermelho. Cor fica
// reservada para affordance (azul = acao/foco), nunca para informacao.
//
// Uma marca por significado, nao por rotulo: VAZIA e ABORTOU sao os dois ❌ e
// quem os separa e o texto ao lado. Se um estado precisar de marca propria,
// adicione aqui em vez de escrever o emoji solto no JSX.
export const MARK = {
  OK: '✅',        // prenhe, aprovada, confirmada, paga, concluida
  BAD: '❌',       // vazia, reprovada, nao confirmada, abortou
  UNKNOWN: '❓',   // inconclusivo, indefinido
  PENDING: '⏳',   // aguardando, a receber
  WARN: '⚠️',      // fora do esperado, precisa de atencao
  CRITICAL: '🚨',  // atraso que custa dinheiro
  COBRANCA: '💲',  // o local do cliente para onde vai o boleto
};

// Estado que vale para *toda* linha nao carrega informacao — um ✅ em 100% das
// linhas e so ruido. Por isso so "Finalizado" ganha marca: o que o usuario
// procura na lista e "ja acabou ou nao", e a ausencia da marca ja responde.
export const SERVICE_STATUS_MARK = {
  'Finalizado': MARK.OK,
};
